"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountPopup = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerAccountPopup(eventLabel, nonInteraction = true) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'CustomerAccount',
        eventAction: 'Popup',
        eventLabel,
        nonInteraction,
    });
}
exports.trackCustomerAccountPopup = trackCustomerAccountPopup;
//# sourceMappingURL=trackCustomerAccountPopup.js.map